var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-4);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3-5);\n      }\n\n      .cls-3 {\n        fill: url(#GradientFill_3-6);\n      }\n\n      .cls-4 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-5 {\n        fill: url(#GradientFill_3-3);\n      }\n\n      .cls-6 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 24.97,
    y1: 49.96,
    x2: 24.97,
    y2: 0.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 25,
    x2: 25,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-3",
    "data-name": "GradientFill 3",
    x1: 25,
    x2: 25,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-4",
    "data-name": "GradientFill 3",
    x1: 18.61,
    y1: 49.96,
    x2: 18.61,
    y2: 0.1,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-5",
    "data-name": "GradientFill 3",
    x1: 31.4,
    x2: 31.4,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-6",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50,
    x2: 25,
    y2: 0.14,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.54,35.22c0-.29-.07-.54-.12-.77-.12-.23-.23-.4-.42-.58-.23-.12-.47-.23-.7-.3-.37-.05-.65-.12-1-.12h-3.13l-1.77,8.38h2.36l.65-3.18h.7c.42,0,.84,0,1.19-.12.35-.11.63-.23.93-.47.3-.25.53-.53.77-.84.18-.35.35-.77.42-1.17.12-.3.12-.6.12-.83ZM26.07,36.06c-.07.17-.12.35-.19.47-.07.11-.18.23-.23.28-.12.07-.19.12-.3.12-.05.07-.17.07-.28.07h-.3l.42-1.82h.23c.12-.07.17,0,.28,0,.07,0,.12.05.25.11,0,.05.05.12.05.17.07.06.07.18.07.23v.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.25,30.44c-.18-.05-.42-.05-.59-.12-.23-.05-.53-.11-.77-.16-.7-.07-1.42-.12-2.07-.19-.89-.05-1.7-.12-2.59-.12-.42.42-.82.89-1.24,1.24-.42-.35-.82-.82-1.24-1.24-.88,0-1.7.07-2.59.12-.65.07-1.35.12-2.07.19-.23.05-.52.11-.77.16-.17.07-.4.07-.59.12-.12.07-.23.11-.35.18q-.06.07-.12.12v.18c.05.05.12.05.12.11.19.05.3.12.47.17.23.07.47.11.72.11.28.06.63.12.94.19.82.11,1.65.18,2.47.18,1,.05,2.01.12,3.01.12s2.01-.07,3.01-.12c.82,0,1.66-.07,2.47-.18.3-.07.65-.12.95-.19.23,0,.47-.05.7-.11.18-.05.3-.12.47-.17,0-.06.07-.06.12-.11v-.18q-.05-.05-.12-.12c-.12-.07-.23-.12-.35-.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.98,20.59c.42.89.84,1.72,1.35,2.54.48.82.95,1.59,1.54,2.31.89,1.23,1.82,2.41,2.83,3.47.42.47.84.94,1.3,1.35.47-.42.89-.88,1.31-1.35,1-1.07,1.94-2.24,2.82-3.47.59-.72,1.07-1.49,1.54-2.31.52-.82.94-1.66,1.36-2.54.35-.88.7-1.77.93-2.71.23-.89.35-1.77.35-2.71,0-2.19-.87-4.31-2.41-5.85-1.59-1.59-3.71-2.48-5.9-2.48s-4.3.89-5.9,2.48c-1.52,1.54-2.41,3.66-2.41,5.85,0,.93.12,1.82.35,2.71.23.94.59,1.82.94,2.71ZM22.58,12.75c.65-.58,1.54-1,2.42-1s1.77.42,2.42,1c.65.65,1,1.54,1,2.42s-.35,1.77-1,2.41c-.65.65-1.54,1-2.42,1s-1.77-.35-2.42-1c-.63-.64-1-1.53-1-2.41s.37-1.77,1-2.42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.75,37.23l-.35,1.59h.7l-.17.53c0,.18-.07.35-.12.47,0,.12-.07.23-.12.3-.18.23-.42.35-.65.3h-.18c-.05-.07-.12-.07-.12-.12-.05-.07-.05-.12-.12-.19v-.23c0-.18,0-.35.07-.59l.75-3.43c0-.18.07-.3.14-.47.05-.12.12-.23.17-.3.12-.17.3-.3.54-.3.05,0,.12.07.17.07.07,0,.13.07.13.07.05.05.12.11.12.17v.23c0,.12,0,.3-.06.42l-.05.35h2.17c.12-.35.12-.7.19-1.05,0-.25-.07-.53-.19-.77-.12-.23-.23-.41-.42-.53-.23-.18-.47-.3-.77-.35-.35-.07-.64-.11-.99-.11-.3,0-.65.05-.95.11-.23,0-.54.12-.77.24-.47.18-.82.53-1.17.93-.06.18-.18.37-.3.53-.07.18-.18.42-.23.65-.24.65-.35,1.24-.54,1.89-.05.47-.17.94-.23,1.4-.05.37-.12.72-.12,1,0,.3.07.6.12.83.07.23.18.47.35.59.18.18.35.3.59.41.3.05.54.12.84.12.23,0,.42-.07.58-.07.19-.05.35-.12.54-.17.3-.12.59-.35.77-.65h.05l-.12.7h1.65l1-4.6h-2.89Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.15,33.68c-.23-.12-.47-.23-.7-.29-.37-.07-.72-.11-1.07-.11s-.7.05-1.05.11c-.37.12-.65.24-.95.42-.35.23-.65.52-.82.87-.12.19-.23.37-.3.6-.12.23-.18.47-.23.7-.07.23-.07.47-.12.7,0,.19.05.3.12.48.05.17.12.28.23.4.12.11.23.23.35.35.19.13.42.25.6.37.35.17.7.4,1.05.58.12.05.18.12.3.23.05.07.05.18.05.3,0,.23-.05.47-.17.63-.07.13-.18.25-.25.3-.12.07-.23.07-.35.07h-.17c-.07-.07-.12-.07-.18-.12,0-.07-.05-.07-.05-.12-.07-.13-.07-.18-.07-.25,0-.05,0-.17.07-.24l.05-.4h-2.24l-.05.23c-.07.23-.12.52-.12.82,0,.23.05.53.17.77.12.19.24.35.47.47.18.18.49.23.72.3.28.05.63.12,1,.12.47,0,1-.07,1.41-.18.42-.12.77-.23,1.07-.47.28-.23.54-.53.7-.82.23-.42.35-.83.47-1.24.07-.25.07-.48.07-.65,0-.3-.07-.59-.19-.84-.12-.23-.28-.47-.52-.64h-.07l-.3-.18-1-.47c-.12-.07-.17-.12-.29-.19-.07-.05-.18-.12-.23-.17-.12-.18-.18-.3-.18-.48,0-.23.07-.4.18-.59.12-.16.29-.3.52-.3.07,0,.12.07.18.07s.12.07.12.07c.07.05.07.11.12.16v.42l-.12.35h2.24c.07-.3.12-.65.12-.93,0-.25-.05-.49-.17-.72-.07-.23-.25-.4-.42-.53Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,0C11.21,0,0,11.22,0,25s11.21,25,25,25,25-11.21,25-25S38.79,0,25,0ZM25,46.94c-12.1,0-21.94-9.84-21.94-21.94S12.9,3.06,25,3.06s21.94,9.84,21.94,21.94-9.84,21.94-21.94,21.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGps);
export default __webpack_public_path__ + "static/media/Icon_GPS.6116a0f35817b018fbcbcfb1f5092e32.svg";
export { ForwardRef as ReactComponent };